import { render, staticRenderFns } from "./course-item-model.vue?vue&type=template&id=da913934&scoped=true&"
import script from "./course-item-model.vue?vue&type=script&lang=js&"
export * from "./course-item-model.vue?vue&type=script&lang=js&"
import style0 from "./course-item-model.vue?vue&type=style&index=0&id=da913934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da913934",
  null
  
)

export default component.exports